/** @format */
import { Suspense } from 'react';
import { fetchCategories } from './utils';
import { CategoriesSection } from './components';

const Category = () => {
  const categoriesData = fetchCategories({});

  return (
    <Suspense fallback={<CategoriesSection categoriesData={null} />}>
      <CategoriesSection categoriesData={categoriesData} />
    </Suspense>
  );
};

export default Category;
